import React from "react";
import "./about.css";
// import "../../index.css";

const pastContributors = [
  "Arundhati Pande, Policy & Strategy Analyst",
  "Ashray KB, Software Developer",
  "Danling Jiang, Full-stack Developer",
  "Devarishi Shinde",
  "Ekta Chandrakar, Marketing Manager",
  "Emily Jones, Project Manager",
  "Fuzel Hafiz, Operations & QA",
  "Gouthami Vanathadupula, Software Developer",
  "Harshita Patil, Software Engineer",
  "Hemaxi Barot",
  "James Johnson, Software Engineer",
  "Karen Tsai, UX & Content",
  "Laura P. Guereschi, Marketing Manager",
  "Madhura Jadhav, People & Product Manager",
  "Mitra Sarangi, Data Analyst",
  "Murat Barlas, UX and Data Visualization Designer",
  "Piyush Shelke, Corporate Partnerships Manager",
  "Prabhakaran Jayasankar, SEO & Analytics",
  "Roberta Lacerda",
  "Sadiya Bhawania, Full Stack Developer",
  "Sudhanshu Deshpande, Data Analyst",
  "Swapna Palavesa Kannan, Lead UX/UI Strategist",
  "Vaishnavi Vembar, Marketing Manager",
  "Valka Gupta, Business & Content",
  "Varun Kaza, Data Manager",
  "Venkata Sai Sumanth Uppuluru, Product Manager",
];

const currentContributors = [
  "Amanda Jones, Instructional Designer",
  "Anvay Sethi, Visual Media Artist",
  "Arnav Anand, Machine Learning Engineer",
  "Astha Rastogi, Software Developer",
  "Atharva Deshmukh, AI solutions architect",
  "Balakrishnan Iyer, Data Scientist",
  "Brianna Shuler, Instructional Designer",
  "Chaitanya Kishore, Program Manager",
  "Chaitanya Patil, Data Engineer",
  "Chaitrali Patne, Product Manager",
  "Chukwufunaya Okpah, Product Manager",
  "Dhanush Nandish, UI/UX Designer",
  "Divya Sree Gandikota, UI/UX Designer",
  "Emerald Paul, Business Analyst",
  "Haripriya Vijayan, Product Manager",
  "Hrithik Sanyal, Product Designer",
  "Jessica Lee Allen, Instructional Designer",
  "Laila Rahman, HR Recruiting & Operations",
  "Lavina Chugh, Software Developer",
  "Minakshi Mandal, Vice President HR",
  "Natalia Chernysheva, Software Developer",
  "Pankaj Paneri, Project Manager",
  "Pavan Umesh, R&D engineer",
  "Rasika Kole, Data Analyst",
  "Rebekah Fyneface, IT Administrator",
  "Shubhi Singla, Program Manager",
  "Siva Deekshith Inturi, Frontend Developer",
  "Srajit Rastogi, Software Developer",
  "Venkata Sri Deepthi SriKotaPeetambaram, Data Analyst",
  "Vinaya Bomnale, Software Developer",
  "Vooha Sree Chitta, Data Scientist",
];

const TopSection = () => {
  return (
    <div className="container">
      <div className="about_title">
        <h1>Team</h1>
      </div>
      <div className="corewebteam">
        <div className="team_column">
          <div>
            <h3>Current Core Team</h3>
            <br></br>
            {currentContributors &&
              currentContributors.map((c) => (
                <>
                  {" "}
                  <p>{c}</p>
                  <br />
                </>
              ))}
            <br></br>
          </div>
          <div></div>
          <div>
            <h3>Past Contributors</h3>
            <br></br>
            {pastContributors &&
              pastContributors.map((c) => (
                <>
                  {" "}
                  <p>{c}</p>
                  <br />
                </>
              ))}
            <br></br>
            <br></br>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopSection;
